import { gql } from '@apollo/client'
import { STORE_FRAGMENT } from '../fragments'

export const GET_STORE = gql`
  query GetStore($storeId: ID!) {
    store(storeId: $storeId) {
      ...Store
    }
  }
  ${STORE_FRAGMENT}
`
